import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import { connect } from 'react-redux'
import Logo from '../assets/newblacklogo.png'
import SettingsIcon from 'react-icons/lib/md/settings'
import SearchIcon from 'react-icons/lib/fa/search'
import VideosIcon from 'react-icons/lib/md/video-collection'
import AccountIcon from 'react-icons/lib/md/account-box'
import './navbar.css'

const mapStateToProps = (state, ownProps) => {
  const { me } = state

  return {
    me,
    view: ownProps.viewParams.view || '',
  }
}

class NavbarComp extends Component {
  constructor() {
    super()

    this.state = {
      lastLive: 0,
    }
    this.setState = this.setState.bind(this)
  }

  render() {
    const { me, view } = this.props
    const navElements = []
    navElements.push(
      <a href="/" className="nav-btn" key="logo">
        <img className="logo" src={Logo} role="presentation" />
      </a>
    )
    navElements.push(
      <div className="spacer" key="spacer" />
    )
    if (me.user_name) {
      if (view === 'settings') {
        navElements.push(
          <Link
            key="userLink"
            className={`nav-item`}
            to="/"
          >
            Close
          </Link>
        )
      } else {
        navElements.push(
          <Link
            key="userLink"
            className={`nav-item`}
            to="/settings"
          >
            Settings
          </Link>
        )
      }
    } else {
      navElements.push(
          <Link
            key="userLink"
            className="nav-item"
            to="/signup"
          >
            Sign Up
          </Link>
        )
    }

    return (
      <div className="app-nav">
        <nav className="navbar navbar-full">
          {navElements}
        </nav>
      </div>
    )
  }
}

export default connect(
  mapStateToProps
)(NavbarComp)



// WEBPACK FOOTER //
// ./src/nav/Navbar.js